import { showToastMessage } from "@almafintech/react-components";
import * as Sentry from "@sentry/react";
import { FormikValues } from "formik";
import InteractiveBrokersToken from "../../components/InteractiveBrokersToken/InteractiveBrokersToken";
import {
  getPromoters,
  requestEmailVerification,
} from "../../connectors/interactiveBrokers";
import {
  labels,
  placeholders,
  titles,
} from "../../i18n/interactiveBrokers/tokenStep";
import { onUpdateInteractiveBrokersData } from "../../reducers/interactiveBrokersReducer";
import {
  onUpdateCompletedStep,
  onUpdateStep,
  onUpdateSubStep,
} from "../../reducers/onboardingDataReducer";
import { Step } from "../../types";
import { genericToastifyError } from "../../utils";
import { validationsForLanguage } from "../../validations";

const tokenStep = ({ language = "es" }: { language: "es" | "en" }): Step => {
  const validations = validationsForLanguage(language);

  return {
    step: 1,
    name: titles[language].stepper,
    hideLayoutButtons: true,
    showLanguagePicker: true,
    subSteps: [
      {
        step: 1,
        name: titles[language].email,
        titleOfStep: titles[language].email,
        hideStepper: true,
        fields: [
          {
            name: "email",
            type: "email",
            label: labels[language].email,
            validation: validations.emailRequired,
            initialValue: "",
            placeholder: placeholders[language].email,
          },
        ],
        onContinue: async (values: FormikValues) => {
          try {
            const { email } = values;
            await requestEmailVerification({
              email,
              language_preference: language,
            });

            if (email) {
              Sentry.setUser({ email });
            }
            return { newValuesToForm: { email } };
          } catch (error) {
            console.error("Error verifying email:", error);
            Sentry.captureException(error);
            showToastMessage(genericToastifyError, {
              containerId: "formAlert",
              type: "error",
            });
          }
        },
      },
      {
        step: 2,
        name: titles[language].validation,
        component: (dispatch, _state, formik) => (
          <InteractiveBrokersToken
            email={formik?.values?.email as string}
            language={language}
            onBackClicked={() => {
              dispatch(onUpdateStep(1));
              dispatch(onUpdateSubStep(1));
            }}
            onAuthorizationSuccesful={async () => {
              // Populate promoters array for next step now that JWT token was aquired
              try {
                const response = await getPromoters();
                dispatch(
                  onUpdateInteractiveBrokersData({
                    promoters: response.data ?? [],
                  })
                );
              } catch (error) {
                console.error("Error getting promoters:", error);
                Sentry.captureException(error);
                // No need to show an error toast, promoters will simply remain
                // empty and no select will show up
              }

              dispatch(onUpdateCompletedStep(1));
              dispatch(onUpdateSubStep(1));
              dispatch(onUpdateStep(2));
            }}
          />
        ),
      },
    ],
  };
};

export default tokenStep;
